export default __webpack_public_path__ + "static/media/red-onion.494ce1ae.jpg";